import React from 'react';
import { FaHackerrank } from 'react-icons/fa';
import { SiCodechef, SiCodeforces, SiGeeksforgeeks, SiLeetcode } from 'react-icons/si';

const Profiles = () => {
  const profiles = [
    {
      icon: <SiCodechef />,
      name: 'CodeChef',
      link: 'https://www.codechef.com/users/smit_kbgd16'
    },
    {
      icon: <SiGeeksforgeeks />,
      name: 'GeeksForGeeks',
      link: 'https://www.geeksforgeeks.org/user/smitkbgd/'
    },
    {
      icon: <SiLeetcode />,
      name: 'LeetCode',
      link: 'https://leetcode.com/u/smitkbgd/'
    },
    {
      icon: <SiCodeforces />,
      name: 'CodeForces',
      link: 'https://codeforces.com/profile/Smit_kbgd'
    },
    {
      icon: <FaHackerrank />,
      name: 'HackerRank',
      link: 'https://www.hackerrank.com/profile/smitkbgd'
    }
  ];

  return (
    <div className="p-4">
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
        {profiles.map((profile, index) => (
          <div key={index} className="flex flex-col items-center cursor-pointer rounded hover:bg-[#0001]" onClick={() => window.open(profile.link, '_blank')}>
            <div className="text-5xl mb-2">{profile.icon}</div>
            <span>{profile.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Profiles;
